import { useAuth } from '../context';

export const useFeatures = () => {
	const { state } = useAuth();
	const features = !state.userToken ? [] : state.features;

	return new Set(features);
};
